<template>
  <goods-selector v-model="$$FormData[config.__key]"/>
</template>

<script>
export default {
  name: 'Goods'
}
</script>

<style scoped lang="scss">

</style>